module.exports = __webpack_public_path__ + "img/banner-LUISS.f3de07e4.jpg";